import "bootstrap/dist/css/bootstrap.css";
import "@mony-group/mse-tool-components/global.css";
import "@mony-group/mse-tool-components/all.css";
import "mse-tools-masthead-and-footer/lib/css/masthead-v2.css";
import "mse-tools-masthead-and-footer/lib/css/tip-popup.css";
import "mse-tools-masthead-and-footer/lib/css/footer.css";
import "./src/scss/index.scss";

import { mseGTM } from "mse-tools-masthead-and-footer/lib/mse-gtm";

if (typeof window !== "undefined") {
  mseGTM();
}

const onInitialClientRender = () => {
  window.__gcse = {
    $ready: false,
    searchCallbacks: {},
    initializationCallback: () => {
      // console.log("initialization callback", ...args);
      window.__gcse.$ready = true;
      window.dispatchEvent(new CustomEvent("mse:legacy-search:init"));
    },
  };
  const s = document.createElement("script");
  s.setAttribute("async", "async");
  s.setAttribute("src", "https://cse.google.com/cse.js?cx=7c61b9f1e98273104");
  document.head.appendChild(s);
};

export { onInitialClientRender };
